import { configUiMenu_mobile_vertical as  configUiMenu_default} from "src/library/minigame_client/ui/menu"

export let configUiMenu_mobile_vertical = _.cloneDeep(configUiMenu_default);

configUiMenu_mobile_vertical.sndBtnClick = "res/sounds/btn_click";
configUiMenu_mobile_vertical.buttonHelpPosition     = {x: 311, y: 7};
configUiMenu_mobile_vertical.buttonSettingsPosition = {x: 385, y: 7};
configUiMenu_mobile_vertical.buttonAutoOnPosition   = {x: 461, y: 7};
configUiMenu_mobile_vertical.buttonAutoOffPosition  = {x: 461, y: 7};
configUiMenu_mobile_vertical.buttonExitPosition     = {x: 7, y: 7};
configUiMenu_mobile_vertical.buttonSoundOnPosition  = {x: 79, y: 7};
configUiMenu_mobile_vertical.buttonSoundOffPosition = {x: 79, y: 7};


//////////////////
// WEBPACK FOOTER
// ./cfg/mobile_vertical/menu.es6
// module id = 46
// module chunks = 0